module.exports = __webpack_public_path__ + "static/media/Montserrat-BoldItalic.6fa63549.woff";